import Field from './Field';
import RichTextField from '../components/RichTextField';

/* global m */

export default class Content extends Field {
    whiteListConfigProperties() {
        return [
            'content',
        ];
    }

    configure() {
        return m('.Form-group', RichTextField.component({
            value: this.getConfig('content'),
            onchange: m.withAttr('value', this.setConfig('content')),
            disabled: this.disabled,
        }));
    }

    fillView() {
        return m('div', m.trust(this.getConfig('contentHtml')));
    }

    displayView() {
        return null;//TODO: as option?
    }
}
